import React from 'react';
import { Link } from 'react-router-dom';

function ToggleLink(props) {
  return (
    <div className="navLinkCont" onClick={props.handleClick}><Link className="navLink" to={props.to}>{props.children}</Link></div>
  );
};

export default ToggleLink